import eventType from '../../shares/enums/eventType';
import eventEmitters from '../../shares/lib/eventEmitters';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import logger from '../../shares/lib/logger';
import validateGameOtpConfig from '../../shares/lib/validateGameOtpConfig';
import { ResponseSource } from '../../shares/types/SwipeSDKConfigType';
import { getGameLaunchUrl } from '../gameLauncherUrl';
import OTPService from '../playForRealGame/OTPService';
import { generateNonce } from '../../shares/lib/generateNonce';

export const loadIframe = (gameData: string) => {
  const loaderIcon = document.querySelector(
    '#mini-game-root #mini-game-spinner',
  ) as HTMLElement;
  const iframe = document.createElement('iframe');
  iframe.src = typeof gameData === 'string' ? gameData : '';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.border = 'none';

  iframe.addEventListener('load', () => {
    if (loaderIcon) {
      loaderIcon.style.display = 'none';
    }
  });

  const miniGameIframeContainer = document.querySelector(
    '#mini-game-root #mini-game-frame',
  );
  if (miniGameIframeContainer) {
    miniGameIframeContainer.replaceChildren(iframe);
  }
};

export const generateFinalUrl = async (gameId: string | undefined) => {
  let finalUrl: string | null = '';
  try {
    const swipeSDKConfig = getSDKConfig();
    const isValid = validateGameOtpConfig(swipeSDKConfig.otpConfig);
    if (!isValid) {
      return null;
    }

    const otpService = new OTPService(swipeSDKConfig.otpConfig);
    const responseOTP = await otpService.getOTP(gameId);
    if (!responseOTP) {
      throw new Error('Game OTP Not Found');
    }
    return getGameLaunchUrl(
      swipeSDKConfig.miniGames?.gameLaunchConfig as never,
      gameId,
      responseOTP,
    );
  } catch (error) {
    logger.error('Error processing gameData' , { error });
  }
  if (!finalUrl) {
    logger.error('Invalid gameData or failed to generate URL');
    return null;
  }
  return finalUrl;
};

export const renderGameUI = async (responseSourceInput: ResponseSource) => {
  const { gameData, placeHolderDom } = responseSourceInput;
  if (!gameData) {
    logger.error('No gameData provided');
    return;
  }

  const swipeSDKConfig = getSDKConfig();
  let finalUrl: string | null = null;

  if (
    swipeSDKConfig.miniGames?.urlCallbackFn &&
    typeof swipeSDKConfig.miniGames.urlCallbackFn === 'function'
  ) {
    try {
      const generatedNonce = generateNonce();
      const callbackResult = await swipeSDKConfig.miniGames.urlCallbackFn(
        generatedNonce,
        {
          gameId: gameData as string,
        },
      );

      if (
        callbackResult &&
        typeof callbackResult === 'object' &&
        'url' in callbackResult &&
        'nonce' in callbackResult
      ) {
        if (callbackResult.nonce !== generatedNonce) {
          logger.error('Nonce mismatch: callback returned invalid nonce');
          return;
        }

        const url = callbackResult.url;
        if (!url || typeof url !== 'string' || url.trim() === '') {
          logger.error('Invalid URL from callback');
          return;
        }

        try {
          new URL(url);
          finalUrl = url;
          logger.info('Using URL from urlCallbackFn callback', { url });
        } catch (error) {
          logger.error('Invalid URL format from callback', { url, error });
          return;
        }
      } else {
        logger.error('Invalid callback result format');
        return;
      }
    } catch (error) {
      logger.error('Error calling urlCallbackFn', { error });
      return;
    }
  } else {
    finalUrl = await generateFinalUrl(gameData as string);
  }

  eventEmitters(eventType.MINIGAME_LOAD, 'MiniGame', {
    eventType: eventType.MINIGAME_LOAD,
  });

  if (finalUrl) {
    loadIframe(finalUrl);
  }
};
